import React from 'react';
import { Navigate } from 'react-router-dom';

// Simple auth check - you can enhance this with Redux or Context
const PrivateRoute = ({ children }) => {
  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/v2/login" replace />;
  }

  return children;
};

export default PrivateRoute;
